// components/Modals/BaseModal.jsx
import React from "react";

const BaseModal = ({ open, onClose, children }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      {/* overlay */}
      <div
        className="absolute inset-0 bg-black/70"
        onClick={onClose}
      />

      {/* modal */}
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-xl z-50">
        {children}
      </div>
    </div>
  );
};

export default BaseModal;
